// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Satoshi_bb3f1d', '__Satoshi_Fallback_bb3f1d'"},"className":"__className_bb3f1d"};